import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "./Dashboard.css";
import "./PopUp.css";
import "../WNewUserTutorials/PopupBoxStyle.css";

import {
  New_ScrollX2025,
  WavingHand,
  laptopScreenV3,
} from "../../assets/icons";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProjectsByPagination } from "../../Redux/actions/projectsActions";
import {
  createProject,
  deleteAProject,
  createAGoogleProject,
  renameProject,
  updateProjectStatus,
  createCardProject,
} from "../../Redux/actions/projectActions";
import {
  skipUserModel,
  allTemplatesList,
  getCurrentPlan,
  userSeenTutorial,
  selectedPageOption,
} from "../../Redux/actions/commonActtion";
import { AiOutlineDelete } from "react-icons/ai";
import { FaClone } from "react-icons/fa";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { SiGooglesheets } from "react-icons/si";
import { FiSearch, FiMoreVertical, FiArrowRight, FiX } from "react-icons/fi";
// import { toast } from "react-toastify";
import { read, utils } from "xlsx";
import Modal from "react-modal";

import { NavBar } from "../../UiComponents/index";
import { excelDataToProjectData } from "../../services/excelDataToProjectData";
import CloneProjectModal from "../ProjectV2/CloneProject/CloneProjectModal";
import UserInputModal from "./userInputModal";
import CreateCustomProjectModal from "./CreateCustomProjectModal";
import TemplatePreviewModal from "./TemplatePreviewModal";
import { Loader, Button, Loader2 } from "../../Components";
import SuccessModal from "./SuccessModal";
import Templates from "./Templates";
import ScrollTemp from "./ScrollTemp";
import { mergeTemplatesWithCatalog } from "./templateCatalog";

import { LuLoader2 } from "react-icons/lu";
import ProjectSkeleton from "../../Components/SkeletonLoader/ProjectSkeleton";
import ThemeSelect from "../../Components/Dropdown/ThemeSelect";
import Navbar from "../ProjectV2/Navbar/Navbar";
import { toast, ToastContainer } from "react-toastify";
import CustomToast, {
  defaultcustomToatStyle,
  customToatStyleError,
} from "../../Components/CustomToast/CustomToast";

const PROJECT_PAGE_SIZE = 6;
const SEARCH_DEBOUNCE_MS = 350;

const TYPE_FILTER_OPTIONS = [
  { label: "All Types", value: "All" },
  { label: "Scroll", value: "Scroll" },
  { label: "Card", value: "Card" },
];

const SORT_OPTIONS = [
  { label: "Recent First", value: "Recent First" },
  { label: "Oldest First", value: "Oldest First" },
  { label: "Name", value: "Name" },
];

export default function Dashboard(setIsPreviewOpen) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSent, setIsSent] = useState(false);
  const [isProjectOpen, setIsProjectOpen] = useState(false);

  const [dateSort, setDateSort] = useState("desc");
  const [isNoticeDisplay, setIsNoticeDisplay] = useState(false);
  const [projectCloneModalOpen, setProjectCloneModalOpen] = useState(false);
  const [newProjectInputModalOpen, setNewProjectInputModalOpen] =
    useState(false);
  const [selectedTemplatePreview, setSelectedTemplatePreview] = useState(null);
  const [templatePreviewOpen, setTemplatePreviewOpen] = useState(false);

  const [ProjectType, setProjectType] = useState("scroll");
  const [projectName, setProjectName] = useState("");
  const [resolution, setResolution] = useState("");
  // console.log("ProjectType ", ProjectType, "   resolution = ", resolution);

  const [loading, setLoading] = useState(false);
  const [loadOnClone, setLoadOnClone] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [projectLimitModal, setProjectLimitModal] = useState(false);
  const [cloneMsg, setCloneMsg] = useState(false);
  const [allprojectloading, setAllProjectLoading] = useState(true);
  const [production, setProduction] = useState(false);
  const [template, setTemplate] = useState(false);
  const [templateId, setTemplateId] = useState(0);
  const [projectIdForClone, seProjectIdForClone] = useState("");
  const [renameModal, setRenameModal] = useState({
    id: "",
    isOpen: false,
    title: "",
    isCard: false,
  });

  const [options, setOptions] = useState([
    { label: "Draft", value: "Draft" },
    { label: "In Progress", value: "In Progress" },
    { label: "Rendered", value: "Rendered" },
  ]);

  const [size, setSize] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const getStorageData = JSON.parse(localStorage.getItem("skipModels"));
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState(
    getStorageData ? getStorageData.dashModalStatus : true,
  );
  const [isPopupOne, setIsPopupOne] = useState(false);
  const [isPopupsecond, setIsPopupsecond] = useState(false);
  const [isPopupThird, setIsPopupThird] = useState(false);
  // const [isPopupFour, setIsPopupFour] = useState(false);
  const [createProjectRes, setCreateProjectRes] = useState();
  const [pageNo, setPageNo] = useState(1);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const tableWrapRef = useRef(null);
  const loadMoreRef = useRef(null);
  const loadingMoreRef = useRef(false);
  const [allTemplateLoading, setAllTemplateLoading] = useState(true);

  // Toolbar (search / filter / sort) + row actions menu
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("All");
  const [sortBy, setSortBy] = useState("Recent First");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [menuAnchor, setMenuAnchor] = useState(null);

  const updateTutorialStatus = async (status) => {
    await dispatch(userSeenTutorial(status));
  };

  const nextToContinue = (key, val, status) => {
    updateTutorialStatus(status);
  };

  const skipModel = () => {
    dispatch(
      skipUserModel({ dashModalStatus: false, layoutModalstatus: true }),
    );
    setIsWelcomeModalOpen(false);
    localStorage.setItem(
      "skipModels",
      JSON.stringify({ dashModalStatus: false, layoutModalstatus: true }),
    );
    setIsWelcomeModalOpen(false);
    setIsPopupOne(false);
    setIsPopupsecond(false);
    setIsPopupThird(false);
  };

  let { projects, totalProjects } = useSelector((state) => state?.projects);

  const hasMoreProjects = projects.length < totalProjects;

  const templatesList = useSelector(
    (state) => state?.commonReducer?.templates?.data,
  );

  const displayTemplates = useMemo(
    () => mergeTemplatesWithCatalog(templatesList),
    [templatesList],
  );

  const sortByDate = (sortType) => {
    setDateSort(sortType);
    projects = projects.sort((a, b) => {
      if (sortType === "asc")
        return new Date(a.createdAt) - new Date(b.createdAt);
      else return new Date(b.createdAt) - new Date(a.createdAt);
    });
  };

  useEffect(
    (dateSort) => {
      sortByDate(dateSort);
    },
    [projects, setDateSort],
  );

  const detectSize = () => {
    setSize({ winWidth: window.innerWidth, winHeight: window.innerHeight });
  };
  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [size]);

  const handleChangeStatus = (index, value, project_id, isCard) => {
    const idx = options.findIndex((opt) => opt.value === value);
    dispatch(updateProjectStatus(project_id, value, idx, isCard));
  };

  const getAllProject = useCallback(
    (page = 1, { append = false, searchQuery = "" } = {}) => {
      if (append) {
        setIsLoadingMore(true);
        loadingMoreRef.current = true;
      } else {
        setAllProjectLoading(true);
      }

      dispatch(getCurrentPlan());
      return dispatch(
        getProjectsByPagination(
          "",
          PROJECT_PAGE_SIZE,
          page,
          searchQuery,
          append,
        ),
      ).finally(() => {
        if (append) {
          setIsLoadingMore(false);
          loadingMoreRef.current = false;
        } else {
          setAllProjectLoading(false);
        }
      });
    },
    [dispatch],
  );

  const loadMoreProjects = useCallback(() => {
    if (
      loadingMoreRef.current ||
      allprojectloading ||
      !hasMoreProjects
    ) {
      return;
    }

    const nextPage = pageNo + 1;
    setPageNo(nextPage);
    getAllProject(nextPage, { append: true, searchQuery: debouncedSearch });
  }, [
    allprojectloading,
    debouncedSearch,
    getAllProject,
    hasMoreProjects,
    pageNo,
  ]);

  const getAllTemplates = () => {
    setAllTemplateLoading(true);
    dispatch(allTemplatesList()).then(() => {
      setAllTemplateLoading(false);
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, SEARCH_DEBOUNCE_MS);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    if (window.location.href.endsWith("dashboard")) {
      document.getElementById("navbar_0")?.classList?.remove("hidden");
    }
  }, []);

  useEffect(() => {
    setPageNo(1);
    getAllProject(1, { append: false, searchQuery: debouncedSearch });
  }, [debouncedSearch, getAllProject]);

  useEffect(() => {
    getAllTemplates();
  }, []);

  // Warm browser cache so template preview modal opens with images ready
  useEffect(() => {
    for (let i = 1; i <= 12; i++) {
      const img = new Image();
      img.src = `/template-preview/image${i}-new.png`;
    }
  }, []);

  const handleFileInput = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const binaryStr = evt.target.result;
        const wb = read(binaryStr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const jsonData = utils.sheet_to_json(ws, { header: 1 });
        const fileNameWithoutExt = file.name.split(".").slice(0, -1).join(".");
        const projectData = excelDataToProjectData(
          fileNameWithoutExt,
          jsonData,
        );
        dispatch(createProject(projectData));
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      console.log(err);
    }
  };

  const handleProjectCreateError = (res) => {
    const errorMessage =
      res?.response?.data?.message ||
      res?.message ||
      "Something went wrong while creating the project.";
    const isProjectLimitError =
      res?.response?.status === 403 ||
      errorMessage.toLowerCase().includes("plan allows only");

    if (isProjectLimitError) {
      setProjectLimitModal(true);
    } else {
      toast(
        <CustomToast
          isError
          title="Project creation failed"
          content={errorMessage}
        />,
        customToatStyleError,
      );
    }
    setProjectName("");
  };

  const handleGoogleProjectCreateButtonClick = async () => {
    try {
      if (projectName && ProjectType === "card") {
        // console.log("Submit Handler for card ", ProjectType, projectName, resolution);
        await setLoading(true);
        const res = await dispatch(
          createCardProject(projectName, templateId, resolution),
        );
        setCreateProjectRes(res?.success);
        if (res?.success) {
          setNewProjectInputModalOpen(false);
          setSelectedTemplatePreview(null);
          await setLoading(false);
          setProjectName("");
          setCloneMsg("");
          setSuccessMsg("Project has been successfully created.");
          setSuccessModal(true);
        } else {
          await setLoading(false);
          handleProjectCreateError(res);
        }
      } else if (projectName) {
        // console.log(" Submit Handler For Scroll ", ProjectType, projectName, resolution);
        await setLoading(true);
        const res = await dispatch(
          createAGoogleProject(projectName, templateId),
        );
        setCreateProjectRes(res?.success);
        if (res?.success) {
          setNewProjectInputModalOpen(false);
          setSelectedTemplatePreview(null);
          await setLoading(false);
          setProjectName("");
          setCloneMsg("");
          setSuccessMsg("Project has been successfully created.");
          setSuccessModal(true);
        } else {
          await setLoading(false);
          handleProjectCreateError(res);
        }
      }
    } catch (err) {
      await setLoading(false);
      handleProjectCreateError(err);
    }
  };

  const OptionHandler = (val, projectId, isCard) => {
    dispatch(selectedPageOption(val, projectId, isCard));
  };

  const navigateToProject = (projectId, isCard) => {
    OptionHandler("projectLayout", projectId, isCard || false);
    if (isCard) {
      navigate(`/dashboard/card/${projectId}`, {
        state: { isDashboard: false, isCard: isCard },
      });
    } else {
      navigate(`/dashboard/scroll/${projectId}`, {
        state: { isDashboard: false, isCard: false },
      });
    }
  };

  const handleNavigate = (projectId, isCard) => {
    navigateToProject(projectId, isCard);
    localStorage.setItem(
      "isCard",
      JSON.stringify(isCard === true ? true : false),
    );
  };

  useEffect(() => {
    setIsProjectOpen(true);
  }, [navigateToProject]);

  const deleteProject = (projectId, projectName, isCard) => {
    // const confirm = window.confirm(
    //   `Are you sure! You want to delete project (${projectName})?`
    // );
    // if (confirm) dispatch(deleteAProject(projectId, isCard));

    const rawName = projectName || "";
    let displayProjectName = rawName;
    if (rawName.length > 25) {
      const slice = rawName.slice(0, 25);
      const lastSpace = slice.lastIndexOf(" ");
      displayProjectName = `${lastSpace > 0 ? slice.slice(0, lastSpace) : slice}...`;
    }

    const handleConfirm = (closeToast) => {
      console.log(" 1  is Confirm");
      dispatch(deleteAProject(projectId, isCard));
      closeToast();
      setCloneMsg("");
      setSuccessMsg("Project has been successfully deleted.");
      setSuccessModal(true);
    };

    toast(
      ({ closeToast }) => (
        <CustomToast
          title="Are you sure?"
          content={
            <>
              Do you want to delete project <br />({displayProjectName})?
            </>
          }
          onConfirm={() => handleConfirm(closeToast)}
          onCancel={closeToast}
        />
      ),
      defaultcustomToatStyle,
    );
  };

  const handleNewProjectName = async () => {
    if (projectName) {
      await setNewProjectInputModalOpen(false);
      handleGoogleProjectCreateButtonClick();
    }
  };

  const handleRenameProjec = async () => {
    const res = await dispatch(
      renameProject(renameModal?.id, renameModal?.title, renameModal?.isCard),
    );
    if (res?.success) {
      setRenameModal((prev) => ({
        ...prev,
        isOpen: false,
        title: "",
        id: "",
        isCard: false,
      }));
      // toast.success(res?.message);

      setTimeout(() => {
        toast(
          <CustomToast title="" content={res?.message} />,
          defaultcustomToatStyle,
        );
      }, 300);
    } else {
      toast(
        <CustomToast
          isError
          title="Rename failed"
          content={
            res?.message ||
            res?.response?.data?.message ||
            "Something went wrong while renaming the project."
          }
        />,
        customToatStyleError,
      );
    }
  };

  const skeletonComponent = (count = PROJECT_PAGE_SIZE) =>
    Array.from({ length: count }, (_, i) => (
      <ProjectSkeleton key={`project-skeleton-${i}`} />
    ));

  const loadMoreSkeletonCount = Math.min(
    PROJECT_PAGE_SIZE,
    Math.max(totalProjects - projects.length, 0),
  );

  const CloseButton = ({ closeToast }) => (
    <i
      className=" w-7 h-7 flex justify-center cursor-pointer not-italic relative right-[20px]"
      onClick={closeToast}
    >
      ✖
    </i>
  );

  // Client-side type-filter / sort over server-fetched projects.
  const displayProjects = useMemo(() => {
    let list = Array.isArray(projects) ? projects.filter(Boolean) : [];
    if (typeFilter !== "All") {
      const wantCard = typeFilter === "Card";
      list = list.filter((p) => Boolean(p?.isCard) === wantCard);
    }
    const sorted = [...list];
    if (sortBy === "Recent First")
      sorted.sort((a, b) => new Date(b?.createdAt) - new Date(a?.createdAt));
    else if (sortBy === "Oldest First")
      sorted.sort((a, b) => new Date(a?.createdAt) - new Date(b?.createdAt));
    else if (sortBy === "Name")
      sorted.sort((a, b) => (a?.title || "").localeCompare(b?.title || ""));
    return sorted;
  }, [projects, sortBy, typeFilter]);

  const isSearchPending = search.trim() !== debouncedSearch;
  const isProjectListLoading = allprojectloading || isSearchPending;

  useEffect(() => {
    const root = tableWrapRef.current;
    const target = loadMoreRef.current;
    if (
      !root ||
      !target ||
      allprojectloading ||
      !hasMoreProjects ||
      totalProjects <= PROJECT_PAGE_SIZE
    ) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          loadMoreProjects();
        }
      },
      { root, rootMargin: "120px", threshold: 0.1 },
    );

    observer.observe(target);
    return () => observer.disconnect();
  }, [
    allprojectloading,
    displayProjects.length,
    hasMoreProjects,
    loadMoreProjects,
    totalProjects,
  ]);

  return (
    <>
      {" "}
      <ToastContainer closeButton={CloseButton}  bodyClassName={() => "p-2 min-w-[100%]"} />
      {loadOnClone ? (
        <Loader2 label={"Duplicating Project..."} />
      ) : null}
      <div
        className={"tainer w-full h-full"}
        // isOpen={isWelcomeModalOpen}
        // onRequestClose={continueToHomeDashboard}
        contentLabel="Welcome Modal"
      >
        <div
          className="PopUPoneContainer w-full h-full"
          // isOpen={isWelcomeModalOpen}
          // onRequestClose={continueToHomeDashboard}
          contentLabel="Popup Modal"
        >
          {size.winWidth > 1200 ? (
            <div className={"w-full h-full sx-grain sx-gradients DashBoardContainer dashContainer"}>
              {/* Animated particle background (replaces the reference <PageShell />) */}
              <div className="fixed inset-0 pointer-events-none  z-0"></div>
              <div className="particles"></div>
              {/* {successMsg && <SuccessModal successModal={successModal} setSuccessModal={setSuccessModal} deleteMsg={successMsg}/>} */}
              <div className="dashHead">
                <NavBar />
                {/* <Navbar isProjectOpen={isProjectOpen} setIsProjectOpen={setIsProjectOpen}/> */}
              </div>

              <div className="main_dash_block dashBody">
                <div className="main_dash_div">
                  {templatePreviewOpen && selectedTemplatePreview && (
                    <TemplatePreviewModal
                      isOpen={templatePreviewOpen}
                      template={selectedTemplatePreview}
                      onClose={() => {
                        setTemplatePreviewOpen(false);
                        setSelectedTemplatePreview(null);
                      }}
                      onUseTemplate={() => {
                        setTemplatePreviewOpen(false);
                        setProjectName("");
                        const previewType =
                          selectedTemplatePreview?.type === "CARD"
                            ? "card"
                            : "scroll";
                        setProjectType(previewType);
                        setResolution("");
                        setNewProjectInputModalOpen(true);
                      }}
                    />
                  )}
                  {newProjectInputModalOpen && (
                    <CreateCustomProjectModal
                      isOpen={newProjectInputModalOpen}
                      closeModal={() => {
                        setNewProjectInputModalOpen(false);
                        setSelectedTemplatePreview(null);
                        setTemplateId(0);
                        setProjectName("");
                        setProjectType("scroll");
                        setResolution("");
                      }}
                      projectName={projectName}
                      setProjectName={setProjectName}
                      projectType={ProjectType}
                      setProjectType={setProjectType}
                      resolution={resolution}
                      setResolution={setResolution}
                      onCreate={handleNewProjectName}
                      creating={loading}
                      lockedProjectType={
                        selectedTemplatePreview
                          ? String(selectedTemplatePreview.type || "")
                              .toUpperCase() === "CARD"
                            ? "card"
                            : "scroll"
                          : null
                      }
                    />
                  )}
                  {renameModal?.isOpen && (
                    <UserInputModal
                      newProjectInputModalOpen={false}
                      setNewProjectInputModalOpen={setNewProjectInputModalOpen}
                      ProjectType={ProjectType}
                      setProjectType={setProjectType}
                      projectName={projectName}
                      setProjectName={setProjectName}
                      setResolution={setResolution}
                      handleNewProjectName={handleNewProjectName}
                      renameModal={renameModal}
                      setRenameModal={setRenameModal}
                      handleRenameProjec={handleRenameProjec}
                    />
                  )}
                  {loading ? <Loader2 label={"Project Creating..."} /> : null}
                  {successModal && (
                    <SuccessModal
                      key={successMsg || "success"}
                      successModal={successModal}
                      setSuccessModal={setSuccessModal}
                      message={
                        successMsg ||
                        "Project has been successfully created."
                      }
                      onClose={() => {
                        setSuccessMsg("");
                        setCloneMsg("");
                      }}
                    />
                  )}
                  {projectLimitModal && (
                    <Modal
                      isOpen={projectLimitModal}
                      onRequestClose={() => setProjectLimitModal(false)}
                      style={{
                        overlay: {
                          backgroundColor: "rgba(6, 5, 12, 0.72)",
                          backdropFilter: "blur(8px)",
                          zIndex: 200,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                        content: {
                          position: "relative",
                          inset: "auto",
                          width: "min(420px, calc(100vw - 32px))",
                          maxHeight: "calc(100vh - 32px)",
                          margin: "auto",
                          padding: 0,
                          border: "1px solid rgba(124, 92, 255, 0.25)",
                          borderRadius: "20px",
                          background: "#12101c",
                          overflow: "hidden",
                          outline: "none",
                        },
                      }}
                      className="sx-project-limit-modal"
                    >
                      <div className="relative p-7 text-center">
                        <button
                          type="button"
                          onClick={() => setProjectLimitModal(false)}
                          className="absolute top-4 right-4 p-2 rounded-full text-[#625e83] hover:text-white hover:bg-[rgba(255,255,255,0.06)] transition-colors"
                          aria-label="Close"
                        >
                          <FiX className="w-4 h-4" />
                        </button>

                        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[rgba(124,92,255,0.15)] border border-[rgba(124,92,255,0.35)]">
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#c4b2ff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M12 9v4" />
                            <path d="M12 17h.01" />
                            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                          </svg>
                        </div>

                        <h2 className="font-body text-[22px] font-semibold text-white tracking-tight leading-snug px-2">
                          Project limit reached
                        </h2>
                        <p className="font-body text-[14px] text-[#a8a4c8] mt-3 leading-relaxed px-1">
                          You can’t create another project on your current plan.
                          This plan includes one active project of this type per
                          billing cycle.
                        </p>

                        <div className="mt-7 flex flex-col gap-2.5">
                          <button
                            type="button"
                            onClick={() => {
                              setProjectLimitModal(false);
                              navigate("/more_info", { state: { isDashboard: true } });
                            }}
                            className="w-full py-3 rounded-xl bg-[#7c5cff] text-white font-body text-[15px] font-semibold hover:bg-[#9d7dff] transition-all hover:-translate-y-px hover:shadow-[0_8px_24px_-8px_rgba(124,92,255,0.6)]"
                          >
                            Upgrade plan
                          </button>
                          <button
                            type="button"
                            onClick={() => setProjectLimitModal(false)}
                            className="w-full py-3 rounded-xl bg-[rgba(255,255,255,0.04)] border border-[rgba(255,255,255,0.08)] text-[#a8a4c8] font-body text-[15px] font-medium hover:text-white hover:bg-[rgba(255,255,255,0.06)] transition-colors"
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </Modal>
                  )}
                  {projectIdForClone && projectCloneModalOpen && (
                    <div className="">
                      <CloneProjectModal
                        projectCloneModalOpen={projectCloneModalOpen}
                        setProjectCloneModalOpen={setProjectCloneModalOpen}
                        projectId={projectIdForClone}
                        setCloneMsg={(msg) => {
                          // Keep one source of truth so stale delete/create text never wins
                          setSuccessMsg(
                            msg || "Project has been successfully created.",
                          );
                          setCloneMsg("");
                        }}
                        setSuccessModal={setSuccessModal}
                        loading={loadOnClone}
                        setLoading={setLoadOnClone}
                        projectType={ProjectType}
                        onProjectLimitError={() => setProjectLimitModal(true)}
                      />
                    </div>
                  )}

                  <main className="sx-dash w-full max-w-[1388px] mx-auto px-4 md:px-8 py-8 md:py-10">
                    {/* Start a new project */}
                    <section className="pb-[3rem]">
                      <div className="flex items-center gap-2 pb-[22px]">
                        <h2 className="font-body text-white text-[18px] font-medium tracking-tight">
                          Start a new project
                        </h2>
                        {/* <button
                          type="button"
                          title="Help"
                          onClick={() =>
                            window.open(`/help/66f25db207e246eced9ecfda`)
                          }
                          className="w-5 h-5 flex items-center justify-center rounded-full border border-[rgba(255,255,255,0.2)] text-[#a8a4c8] text-[11px] leading-none hover:text-white hover:border-white transition-colors"
                        >
                          i
                        </button> */}
                      </div>
                      <ScrollTemp
                        template={template}
                        templatesList={displayTemplates}
                        setTemplate={setTemplate}
                        setTemplateId={setTemplateId}
                        setNewProjectInputModalOpen={
                          setNewProjectInputModalOpen
                        }
                        onCustomProjectClick={() => {
                          setTemplateId(0);
                          setSelectedTemplatePreview(null);
                          setTemplatePreviewOpen(false);
                          setProjectName("");
                          setProjectType("scroll");
                          setResolution("");
                          setNewProjectInputModalOpen(true);
                        }}
                        onTemplateClick={(item) => {
                          setSelectedTemplatePreview({
                            ...item,
                            type: item?.type || "SCROLL",
                            description: item?.description || "",
                          });
                          setTemplatePreviewOpen(true);
                        }}
                        allTemplateLoading={allTemplateLoading}
                      />
                    </section>

                    {/* My Projects */}
                    <section className="">
                      <div className="h-full border-[1px] border-[rgba(255,255,255,0.08)] bg-[#ffffff05] rounded-[20px] shadow-2xl">
                        {/* Toolbar */}
                        <div className="p-[18px] border-b border-[rgba(255,255,255,0.06)] flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                          <h2 className="font-body text-white text-[18px] font-medium tracking-tight">
                            My Projects
                          </h2>
                          <div className="flex items-center gap-3">
                            <div className="relative">
                              <FiSearch className="w-4 h-4 text-[#625e83] absolute left-3 top-1/2 -translate-y-1/2" />
                              <input
                                type="text"
                                placeholder="Search projects..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                className="h-10 w-[180px] sm:w-[280px] bg-[rgba(255,255,255,0.04)] border-[1px] border-[rgba(255,255,255,0.08)] rounded-xl pl-9 pr-9 text-[13px] text-white outline-none focus:border-[rgba(124,92,255,0.6)] transition-colors"
                              />
                              {isProjectListLoading && search.trim() && (
                                <LuLoader2 className="w-4 h-4 text-[#7c5cff] absolute right-3 top-1/2 -translate-y-1/2 animate-spin" />
                              )}
                            </div>
                            <ThemeSelect
                              value={typeFilter}
                              options={TYPE_FILTER_OPTIONS}
                              onChange={setTypeFilter}
                              ariaLabel="Filter by project type"
                            />
                            <ThemeSelect
                              value={sortBy}
                              options={SORT_OPTIONS}
                              onChange={setSortBy}
                              ariaLabel="Sort projects"
                            />
                          </div>
                        </div>

                        {/* Table */}
                        <div className="sx-tablewrap" ref={tableWrapRef}>
                          <table className="w-full text-left border-collapse min-w-[720px] sx-projects-table">
                            <colgroup>
                              <col className="sx-col-project" />
                              <col className="sx-col-type" />
                              <col className="sx-col-status" />
                              <col className="sx-col-edited" />
                              <col className="sx-col-actions" />
                            </colgroup>
                            <thead>
                              <tr className="border-b border-[rgba(255,255,255,0.06)] text-[16px] text-[#625e83]">
                                <th className="p-3 font-normal font-body">
                                  Project
                                </th>
                                <th className="p-3 font-normal font-body">
                                  Type
                                </th>
                                <th className="p-3 font-normal font-body">
                                  Status
                                </th>
                                <th className="p-3 font-normal font-body">
                                  Last Edited
                                </th>
                                <th className="py-3 pl-3 pr-[30px] font-normal font-body text-right">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {isProjectListLoading
                                ? skeletonComponent()
                                : displayProjects && displayProjects.length ? (
                                displayProjects.map((project, index) =>
                                  project ? (
                                    <tr
                                      key={project?._id || index}
                                      className="border-b border-[rgba(255,255,255,0.04)] hover:bg-[rgba(124,92,255,0.05)] transition-colors group"
                                    >
                                      <td className="p-3">
                                        <div
                                          title={project?.title}
                                          onClick={() =>
                                            handleNavigate(
                                              project?._id,
                                              project?.isCard,
                                            )
                                          }
                                          className="font-medium text-[16px] text-[#f0eeff] tracking-tight capitalize cursor-pointer"
                                        >
                                          {project?.title?.length > 28
                                            ? project?.title.slice(0, 28) +
                                              "..."
                                            : project?.title}
                                        </div>
                                      </td>
                                      <td className="p-3">
                                        <span className="sxTypeBadge font-body inline-block px-2.5 py-1 rounded text-[13px] uppercase tracking-wider">
                                          {project?.isCard ? "Card" : "Scroll"}
                                        </span>
                                      </td>
                                      <td className="p-3">
                                        <ThemeSelect
                                          variant="status"
                                          statusTone={
                                            project?.projectStatus === "Rendered"
                                              ? "green"
                                              : "amber"
                                          }
                                          value={project?.projectStatus || "Draft"}
                                          options={options}
                                          onChange={(nextStatus) =>
                                            handleChangeStatus(
                                              index,
                                              nextStatus,
                                              project?._id,
                                              project?.isCard,
                                            )
                                          }
                                          ariaLabel={`Status for ${project?.title || "project"}`}
                                        />
                                      </td>
                                      <td className="p-3 text-[13px] text-[#a8a4c8]">
                                        {new Date(
                                          project?.updatedAt ||
                                            project?.createdAt,
                                        ).toLocaleDateString()}
                                      </td>
                                      <td className="p-3">
                                        <div className="flex items-center justify-end gap-2 relative">
                                          <button
                                            onClick={() =>
                                              handleNavigate(
                                                project?._id,
                                                project?.isCard,
                                              )
                                            }
                                            className="px-3 py-1.5 rounded-xl bg-[rgba(124,92,255,0.12)] border-[1px] border-[rgba(124,92,255,0.25)] text-[#c4b2ff] text-[14px] font-bold hover:bg-[#7c5cff] hover:text-white transition-colors group-hover:opacity-100 opacity-[0]"
                                          >
                                            Open
                                          </button>
                                          <button
                                            onClick={(e) => {
                                              const willOpen =
                                                openMenuId !== project?._id;
                                              if (willOpen) {
                                                const r =
                                                  e.currentTarget.getBoundingClientRect();
                                                setMenuAnchor({
                                                  top: r.bottom + 6,
                                                  left: r.right,
                                                });
                                              }
                                              setOpenMenuId(
                                                willOpen ? project?._id : null,
                                              );
                                            }}
                                            className="p-1.5 rounded-lg text-[#a8a4c8] hover:text-white hover:bg-[rgba(255,255,255,0.06)] transition-colors"
                                          >
                                            <FiMoreVertical className="w-4 h-4" />
                                          </button>
                                          {openMenuId === project?._id &&
                                            menuAnchor &&
                                            createPortal(
                                              <>
                                                <div
                                                  className="fixed inset-0 z-[90]"
                                                  onClick={() =>
                                                    setOpenMenuId(null)
                                                  }
                                                />
                                                <div
                                                  className="fixed z-[95] w-44 bg-[#171329] border-[1px] border-[rgba(255,255,255,0.1)] rounded-xl shadow-2xl p-1.5"
                                                  style={{
                                                    top: menuAnchor.top,
                                                    left: menuAnchor.left - 176,
                                                  }}
                                                >
                                                  {/* <button
                                                    onClick={() => {
                                                      setOpenMenuId(null);
                                                      handleNavigate(
                                                        project?._id,
                                                        project?.isCard,
                                                      );
                                                    }}
                                                    className="sxMenuItem"
                                                  >
                                                    <FiArrowRight className="w-3.5 h-3.5 mr-2 text-[#a8a4c8]" />
                                                    Open
                                                  </button> */}
                                                  <button
                                                    onClick={() => {
                                                      setOpenMenuId(null);
                                                      setRenameModal(
                                                        (prev) => ({
                                                          ...prev,
                                                          isOpen: true,
                                                          id: project?._id,
                                                          title: project?.title,
                                                          isCard:
                                                            project?.isCard,
                                                        }),
                                                      );
                                                    }}
                                                    className="sxMenuItem font-body"
                                                  >
                                                    <MdOutlineDriveFileRenameOutline className=" w-3.5 h-3.5 mr-2 text-[#a8a4c8]" />
                                                    Rename
                                                  </button>
                                                  <button
                                                    onClick={() => {
                                                      setOpenMenuId(null);
                                                      setProjectCloneModalOpen(
                                                        true,
                                                      );
                                                      seProjectIdForClone(
                                                        project?._id,
                                                      );
                                                      setProjectType(
                                                        project?.isCard
                                                          ? "card"
                                                          : "scroll",
                                                      );
                                                    }}
                                                    className="sxMenuItem font-body"
                                                  >
                                                    <FaClone className="w-3.5 h-3.5 mr-2 text-[#a8a4c8]" />
                                                    Duplicate
                                                  </button>
                                                  {(project?.googleSheetLink ||
                                                    project?.googleSpreadSheetId) && (
                                                    <button
                                                      onClick={() => {
                                                        setOpenMenuId(null);
                                                        window.open(
                                                          project?.googleSheetLink
                                                            ? project?.googleSheetLink
                                                            : `https://docs.google.com/spreadsheets/d/${project?.googleSpreadSheetId}`,
                                                        );
                                                      }}
                                                      className="sxMenuItem font-body"
                                                    >
                                                      <SiGooglesheets className="w-3.5 h-3.5 mr-2 text-[#a8a4c8]" />
                                                      Open Sheet
                                                    </button>
                                                  )}
                                                  <div className="h-px bg-[rgba(255,255,255,0.06)] my-1" />
                                                  <button
                                                    onClick={() => {
                                                      setOpenMenuId(null);
                                                      deleteProject(
                                                        project?._id,
                                                        project?.title,
                                                        project?.isCard,
                                                      );
                                                    }}
                                                    className="sxMenuItem sxMenuDanger font-body"
                                                  >
                                                    <AiOutlineDelete className="w-3.5 h-3.5 mr-2" />
                                                    Delete
                                                  </button>
                                                </div>
                                              </>,
                                              document.body,
                                            )}
                                        </div>
                                      </td>
                                    </tr>
                                  ) : null,
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    className="px-5 py-12 text-center text-[13px] text-[#a8a4c8]"
                                  >
                                    {debouncedSearch || typeFilter !== "All"
                                      ? "No projects available"
                                      : "Create Project to Get Started"}
                                  </td>
                                </tr>
                              )}
                              {isLoadingMore && skeletonComponent(loadMoreSkeletonCount)}
                              {!isProjectListLoading &&
                                hasMoreProjects &&
                                totalProjects > PROJECT_PAGE_SIZE && (
                                  <tr ref={loadMoreRef} className="project-load-more-sentinel">
                                    <td colSpan="5" className="p-0 h-px border-0" />
                                  </tr>
                                )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </section>
                  </main>
                </div>
              </div>
              {/* ==================(1  WELCOME POPUP)==================== */}
              <div
                className={
                  isWelcomeModalOpen === true ? "wmcOverlay" : "wmcOverlayNone"
                }
              >
                {" "}
                <div className="w-full h-full wmcOverlaySecond backdrop-blur-sm"></div>
              </div>

              {isWelcomeModalOpen && (
                <div
                  className={
                    size.winWidth < 1000
                      ? "hideComp"
                      : "welcomeContent backdrop-blur-xl"
                  }
                >
                  <div className="w-full h-full flex flex-col justify-center items-center">
                    <div className="w-full p-4 flex  justify-between items-start cursor-default ">
                      <div className="flex flex-col justify-start items-start">
                        <h1 className="text-[22px] font-bold text-white tracking-tight mb-2">
                          See ScrollX in two minutes.
                        </h1>
                        <p className="text-[16px] text-[#a8a4c8] text-left leading-relaxed max-w-[440px]">
                          Import a sheet. Pick a template. Render. Watch the
                          walkthrough to see how it fits your workflow.
                        </p>
                      </div>
                      <div>
                        <button
                          className=" p-2 bg-[rgba(255,255,255,.03)] hover:bg-[rgba(255,255,255,.08)] text-[#625e83] hover:text-white rounded-full border[1px] border-[rgba(255,255,255,.05)] transition-all"
                          onClick={skipModel}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-x w-4 h-4"
                          >
                            <path d="M18 6 6 18"></path>
                            <path d="m6 6 12 12"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className=" w-full ">
                      <a
  href="javascript:void(0);"
  onClick={() => window.open("/help/", "_blank")}
  target="_blank"
  rel="noreferrer"
  class="block aspect-video bg-black relative overflow-hidden group border-y border-[rgba(255,255,255,.05)]"
>
  <img
    src="https://media.base44.com/images/public/6a3103d205ec28db42ff1b90/40007ab5a_MeetScrollX-VideoStoryboard.jpg"
    alt="ScrollX Walkthrough"
    class="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-[1.02] transition-all duration-700 ease-out"
  />

  <div
    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center bg-black/10 group-hover:bg-transparent transition-colors duration-500"
  >
    <div
      class="w-14 h-14 rounded-full bg-[rgba(255,255,255,.15)] backdrop-blur-md flex items-center justify-center group-hover:scale-110 group-hover:bg-[rgba(255,255,255,.25)] transition-all duration-500 shadow-xl border border-[rgba(255,255,255,.2)]"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-monitor-play w-6 h-6 text-white"
      >
        <path
          d="M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z"
        />
        <path d="M12 17v4" />
        <path d="M8 21h8" />
        <rect x="2" y="3" width="20" height="14" rx="2" />
      </svg>
    </div>
  </div>
</a>
                    </div>
                    {/* <div className="w-full pt-[15px] pb-4 flex flex-col justify-start items-center">
                      <p className="text-base w-full  text-left font-body text-white cursor-default">
                        Watch a short 2-minute walkthrough to quickly learn
                      </p>
                      <p className="text-base w-full  text-left font-body text-white cursor-default">
                        how to create, edit, and render end credits with ease.
                      </p>
                    </div> */}

                    <div className="w-full flex justify-end  p-4 gap-3 align-right ">
                      <button
                        className="px-3 py-2.5 rounded-xl text-[14px] font-medium text-[#a8a4c8] hover:text-white bg-[rgba(255,255,255,.03)] hover:bg-[rgba(255,255,255,.08)] border-[1px] border-transparent hover:border-[rgba(255,255,255,.05)] transition-all"
                        onClick={skipModel}
                      >
                        Skip
                      </button>
                      <button
                        className="px-6 py-2.5 bg-[#7c5cff] text-white rounded-xl text-[14px] font-semibold hover:bg-sx-violet2 hover:shadow-[0_8px_24px_-8px_rgba(124,92,255,.6)] transition-all hover:-translate-y-px"
                        onClick={() => {
                          skipModel();
                          window.open("/help/", "_blank"); // navigate to /help/ in the same tab
                        }}
                      >
                        Watch Now
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div
              id="warning-messageas"
              style={{ width: "100%", height: "100%" }}
            >
              <div className="w-full h-full ">
                {/* ============== */}
                <div
                  className="relative min-h-screen overflow-x-hidden antialiased text-base leading-[1.6] text-sx-ink bg-[#06050c] bg-fixed"
                  style={{
                    fontFamily: "var(--font-body)",
                    backgroundImage:
                      "radial-gradient(circle at 50% 0%, rgba(124,92,255,.1) 0%, transparent 45%), radial-gradient(circle at 20% 90%, rgba(124,92,255,.06) 0%, transparent 50%)",
                  }}
                >
                  {/* Keyframes only — can't be expressed as Tailwind utilities without config */}
                  <style>{`
        @keyframes swd-drift { from { background-position: 0 0; } to { background-position: 200px 200px; } }
        @keyframes swd-pulse { 0%,100% { opacity:.6; transform:scale(.96); } 50% { opacity:1; transform:scale(1.04); } }
        @keyframes swd-twinkle { 0%,100% { opacity:.25; transform:scale(.85); } 50% { opacity:1; transform:scale(1.1); } }
        @media (prefers-reduced-motion:reduce) { .swd-a { animation:none !important; } }
      `}</style>

                  {/* Noise overlay */}
                  <div
                    className="fixed inset-0 pointer-events-none z-[9998] opacity-[.03]"
                    style={{
                      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
                    }}
                  />

                  {/* Particles */}
                  <div
                    className="swd-a fixed inset-0 pointer-events-none z-0 [background-size:200px_200px] [animation:swd-drift_50s_linear_infinite]"
                    style={{
                      backgroundImage:
                        "radial-gradient(circle at 15% 50%,rgba(255,255,255,.08) 1px,transparent 1px),radial-gradient(circle at 85% 30%,rgba(124,92,255,.14) 1.5px,transparent 1.5px),radial-gradient(circle at 50% 80%,rgba(255,255,255,.05) 2px,transparent 2px),radial-gradient(circle at 70% 90%,rgba(124,92,255,.1) 1px,transparent 1px),radial-gradient(circle at 30% 20%,rgba(255,255,255,.1) 1.5px,transparent 1.5px),radial-gradient(circle at 10% 85%,rgba(124,92,255,.16) 1px,transparent 1px),radial-gradient(circle at 90% 60%,rgba(255,255,255,.06) 2px,transparent 2px)",
                    }}
                  />

                  <main className="relative z-[1] min-h-screen mblScreen flex items-center justify-center py-14 px-6">
                    <div className="max-w-[440px] w-full text-center">
                      {/* Logo */}
                      {/* <Link to="/" className="inline-flex items-center gap-[10px] font-semibold text-[15px] tracking-[-0.01em]">
            <div className="w-8 h-8 rounded-[8px] bg-gradient-to-br from-sx-violet2 to-sx-violet flex items-center justify-center">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 8l6 4-6 4M13 16h7" />
              </svg>
            </div>
            ScrollX
          </Link> */}

                      <header className="">
                        <nav className="w-full flex justify-center">
                          <div className="">
                            <Link to="/" className="nav-logo">
                              <span className="nav-logo-icon">
                                <img
                                  className="logo-img999 "
                                  src={New_ScrollX2025}
                                  alt="icon"
                                />
                              </span>
                              <span className="text-white sm:block xl:text-[15px] manrope-300 ">
                                ScrollX
                              </span>
                            </Link>
                          </div>
                        </nav>
                      </header>

                      <h1 className="mt-8 text-[clamp(30px,7vw,38px)] text-white font-bold leading-[1.15] tracking-[-0.03em]">
                        You're in.
                        <br />
                        <em className="not-italic font-light text-sx-violet3">
                          Grab a bigger screen.
                        </em>
                      </h1>
                      <p className="mt-4 text-[15px] text-sx-dim text-white leading-[1.65]">
                        Your plan is active and ready to go. ScrollX's
                        drag-and-drop editing, live 4K preview, and multi-track
                        syncing all feel best on a laptop or desktop.
                      </p>

                      {/* Device illustration */}
                      <div className="relative mx-auto mt-[44px] mb-9 w-[240px] h-[150px]">
                        <div
                          className="swd-a absolute rounded-full [animation:swd-pulse_3.2s_ease-in-out_infinite]"
                          style={{
                            inset: "-20px",
                            background:
                              "radial-gradient(circle, rgba(124,92,255,.22) 0%, transparent 65%)",
                          }}
                        />
                        <svg
                          className="relative w-full h-full"
                          viewBox="0 0 220 130"
                          fill="none"
                        >
                          {/* phone */}
                          <rect
                            x="14"
                            y="25"
                            width="42"
                            height="78"
                            rx="9"
                            stroke="#5a577a"
                            strokeWidth="2"
                          />
                          <rect
                            x="30"
                            y="92"
                            width="10"
                            height="3"
                            rx="1.5"
                            fill="#5a577a"
                          />
                          {/* arrow */}
                          <path
                            d="M60 64 C 72 64, 78 50, 90 44"
                            stroke="#c4b2ff"
                            strokeWidth="2"
                            strokeDasharray="4 5"
                            strokeLinecap="round"
                          />
                          <path
                            d="M83 38 L92 44 L84 50"
                            stroke="#c4b2ff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            fill="none"
                          />
                          {/* sparkles */}
                          <path
                            className="swd-a [animation:swd-twinkle_2.4s_ease-in-out_infinite] [transform-origin:center]"
                            d="M168 8 l2 6 6 2 -6 2 -2 6 -2 -6 -6 -2 6 -2 z"
                            fill="#c4b2ff"
                          />
                          <path
                            className="swd-a [animation:swd-twinkle_2.4s_ease-in-out_infinite_.5s] [transform-origin:center]"
                            d="M206 30 l1.5 4.5 4.5 1.5 -4.5 1.5 -1.5 4.5 -1.5 -4.5 -4.5 -1.5 4.5 -1.5 z"
                            fill="#9d7dff"
                          />
                          <path
                            className="swd-a [animation:swd-twinkle_2.4s_ease-in-out_infinite_1s] [transform-origin:center]"
                            d="M196 92 l1.5 4.5 4.5 1.5 -4.5 1.5 -1.5 4.5 -1.5 -4.5 -4.5 -1.5 4.5 -1.5 z"
                            fill="#c4b2ff"
                          />
                          {/* monitor */}
                          <rect
                            x="84"
                            y="8"
                            width="122"
                            height="78"
                            rx="10"
                            fill="rgba(124,92,255,.08)"
                            stroke="#9d7dff"
                            strokeWidth="2.5"
                          />
                          <rect
                            x="120"
                            y="90"
                            width="50"
                            height="6"
                            rx="3"
                            fill="#9d7dff"
                            opacity=".4"
                          />
                          <path
                            d="M132 86 L122 96 M158 86 L168 96"
                            stroke="#9d7dff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            opacity=".5"
                          />
                          <rect
                            x="98"
                            y="26"
                            width="50"
                            height="4"
                            rx="2"
                            fill="#c4b2ff"
                            opacity=".5"
                          />
                          <rect
                            x="98"
                            y="38"
                            width="70"
                            height="4"
                            rx="2"
                            fill="#c4b2ff"
                            opacity=".35"
                          />
                          <rect
                            x="98"
                            y="50"
                            width="40"
                            height="4"
                            rx="2"
                            fill="#c4b2ff"
                            opacity=".25"
                          />
                          <rect
                            x="98"
                            y="62"
                            width="58"
                            height="4"
                            rx="2"
                            fill="#c4b2ff"
                            opacity=".2"
                          />
                        </svg>
                      </div>

                      <h2 className="mt-1 text-[clamp(20px,5vw,25px)] text-white font-bold tracking-[-0.02em] leading-[1.25]">
                        Built for{" "}
                        <em className="not-italic font-light text-sx-violet3">
                          the big screen.
                        </em>
                      </h2>
                      <p className="mt-[14px] text-[14.5px] text-sx-dim text-white leading-[1.7]">
                        Open ScrollX on your laptop or desktop and we'll have
                        everything ready, no need to redo anything.
                      </p>

                      {/* CTA */}
                      <button
                        type="button"
                        className="group w-full mt-8 p-3 text-[15px] font-medium text-white bg-sx-violet rounded-[10px] border-0 cursor-pointer transition-all duration-200 inline-flex items-center justify-center gap-2 hover:bg-sx-violet2 hover:-translate-y-px hover:shadow-[0_8px_32px_rgba(124,92,255,.35)] disabled:opacity-50 disabled:cursor-not-allowed"
                        style={{ fontFamily: "var(--font-body)" }}
                        onClick={() => setIsSent(true)}
                        disabled={isSent}
                      >
                        {isSent ? (
                          "Link sent"
                        ) : (
                          <>
                            Email Me The Link
                            <span className="text-[18px] transition-transform duration-200 group-hover:translate-x-0.5">
                              →
                            </span>
                          </>
                        )}
                      </button>

                      {isSent && (
                        <div className="mt-[14px] flex items-center justify-center gap-2 bg-[rgba(124,92,255,.1)] border border-[rgba(124,92,255,.25)] rounded-[10px] py-[11px] px-[14px] text-[13px] text-sx-violet3 text-white">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                          Sent. Check your inbox.
                        </div>
                      )}

                      <p className="mt-[22px] text-[13px] text-sx-faint leading-[1.6] text-white">
                        Or just head to{" "}
                        <strong className="text-sx-dim font-medium">
                          app.scrollx.io
                        </strong>{" "}
                        next time you're at your computer.
                      </p>
                    </div>
                  </main>
                </div>
                {/* ============== */}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}